<template>
	<div
		class="detail-panel-shell"
		:class="{ collapsed: modelValue }"
		:style="{ '--detail-panel-width': width, '--detail-panel-right-offset': rightOffset }"
	>
		<div class="detail-panel-content">
			<slot />
		</div>
	</div>

	<button
		v-if="modelValue"
		type="button"
		class="detail-panel-reopen-btn"
		:style="{ top: reopenTop, '--detail-panel-right-offset': rightOffset }"
		:title="reopenTitle"
		@click="emit('update:modelValue', false)"
	>
		<AppIcon :name="IconName.PanelRightOpen" :size="18" :stroke-width="1.2" />
	</button>
</template>

<script setup lang="ts">
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"

withDefaults(
	defineProps<{
		modelValue: boolean
		width?: string
		rightOffset?: string
		reopenTitle?: string
		reopenTop?: string
	}>(),
	{
		width: "var(--width-right-panel)",
		rightOffset: "0px",
		reopenTop: "var(--spacing-4xl)",
	}
)

const emit = defineEmits<{
	(e: "update:modelValue", value: boolean): void
}>()
</script>

<style scoped>
.detail-panel-shell {
	position: fixed;
	top: 0;
	right: var(--detail-panel-right-offset);
	z-index: 10;
	width: var(--detail-panel-width);
	max-width: var(--detail-panel-width);
	height: 100%;
	background-color: var(--neutral-0);
	box-shadow: var(--shadow-base-right);
	overflow: hidden;
	transition: right 0.2s ease;

	&.collapsed {
		right: calc(var(--detail-panel-right-offset) - var(--detail-panel-width));
	}

	.detail-panel-content {
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}
}

.detail-panel-reopen-btn {
	position: fixed;
	top: var(--spacing-4xl);
	right: calc(var(--detail-panel-right-offset) + var(--spacing-md));
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	width: var(--space-40);
	height: var(--space-40);
	border-radius: var(--border-radius-full);
	border: none;
	background: var(--neutral-0);
	color: var(--neutral-600);
	cursor: pointer;
	box-shadow: var(--shadow-lg);
	transition:
		background 0.15s ease,
		color 0.15s ease;

	&:hover {
		background: var(--neutral-100);
		color: var(--neutral-900);
	}
}
</style>
